import { BaseWebComponentDataProvider } from '../../../../framework/BaseWebComponentDataProvider';
import { IntegrityMonitorRuleGridItem } from '../../integrityMonitorRulesGrid/types';
import { IntegrityMonitorAssignationData } from '../types';

export abstract class IntegrityMonitorDefaultRuleConfigurationBaseDataProvider extends BaseWebComponentDataProvider {
  public abstract getRuleAssignationData(ruleSetIds: Array<string>): Promise<IntegrityMonitorAssignationData>;
  public abstract configureDefaultRule(ruleData: IntegrityMonitorRuleGridItem): Promise<Object | null>;
}
